var map = {
	"./favicon.ico": "../hitobito_ssb/app/assets/images/favicon.ico",
	"./logo": "../hitobito_ssb/app/assets/images/logo.svg",
	"./logo.svg": "../hitobito_ssb/app/assets/images/logo.svg",
	"./ssb_bgimage": "../hitobito_ssb/app/assets/images/ssb_bgimage.png",
	"./ssb_bgimage.png": "../hitobito_ssb/app/assets/images/ssb_bgimage.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../hitobito_ssb/app/assets/images sync recursive ^\\.\\/.*$";